var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.labelOnTop) ? _c('div', {
    staticClass: "shareOnText"
  }, [_vm._v(_vm._s(_vm.$t('common.labels.shareOn')) + " ")]) : _vm._e(), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.shareBaseUrl + _vm.item.contentId,
      "title": _vm.item.title,
      "description": _vm.item.description,
      "quote": _vm.item.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "social-links"
          }, [_c('network', {
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "mdi mdi-email"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "mdi mdi-facebook"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "mdi mdi-twitter"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "mdi mdi-linkedin"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d5280fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/shareOnMedia.vue
// module id = a4mb
// module chunks = 1